"use strict";

var _createForOfIteratorHelper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _require = require("../helpers/internal-constants"),
    domSymbolTree = _require.domSymbolTree;

var NODE_TYPE = require("../node-type");

var NonDocumentTypeChildNodeImpl = /*#__PURE__*/function () {
  function NonDocumentTypeChildNodeImpl() {
    _classCallCheck(this, NonDocumentTypeChildNodeImpl);
  }

  _createClass(NonDocumentTypeChildNodeImpl, [{
    key: "nextElementSibling",
    get: function get() {
      var _iterator = _createForOfIteratorHelper(domSymbolTree.nextSiblingsIterator(this)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var sibling = _step.value;

          if (sibling.nodeType === NODE_TYPE.ELEMENT_NODE) {
            return sibling;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return null;
    }
  }, {
    key: "previousElementSibling",
    get: function get() {
      var _iterator2 = _createForOfIteratorHelper(domSymbolTree.previousSiblingsIterator(this)),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var sibling = _step2.value;

          if (sibling.nodeType === NODE_TYPE.ELEMENT_NODE) {
            return sibling;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return null;
    }
  }]);

  return NonDocumentTypeChildNodeImpl;
}();

module.exports = {
  implementation: NonDocumentTypeChildNodeImpl
};